// `/key` at the start of the text or after whitespace, up to the caret.
const TOKEN = /(^|\s)\/([\w-]{0,40})$/;

/** The text typed after `/` before the caret, or null when the caret is not in a shortcut token. */
export function shortcutQuery(text: string, caret: number): string | null {
  const match = TOKEN.exec(text.slice(0, caret));
  return match ? (match[2] ?? '') : null;
}

/** Replaces the `/key` token before the caret with `insert`; returns the new text and caret. */
export function replaceShortcutQuery(
  text: string,
  caret: number,
  insert: string,
): { text: string; caret: number } {
  const before = text.slice(0, caret);
  const match = TOKEN.exec(before);
  if (!match)
    return {
      text: text.slice(0, caret) + insert + text.slice(caret),
      caret: caret + insert.length,
    };
  const start = match.index + (match[1]?.length ?? 0);
  const next = text.slice(0, start) + insert + text.slice(caret);
  return { text: next, caret: start + insert.length };
}
